import { Component, Input, OnInit, AfterViewInit, Optional, Self } from '@angular/core';
import { FormBuilder, FormGroup, NgControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ComparableOperator } from 'app/models/form';
import { ToastService } from 'app/services/toast.service';
import { BaseAnswerTypeComponent } from '../base-answer-type.component';

@Component({
  selector: 'app-date-range',
  templateUrl: './date-range.component.html',
  styleUrls: ['./date-range.component.scss']
})
export class DateRangeComponent extends BaseAnswerTypeComponent<number | number[]> implements OnInit {

  @Input() formGroup: FormGroup;
  @Input() controlName: string;
  @Input() labelFrom: string;
  @Input() labelTo: string;
  @Input() labelRange: string;
  @Input() placeholder: string = '';
  @Input() minDate: Date = null;
  @Input() detailMode: boolean = false;
  @Input() required: boolean = false;
  @Input() readonly: boolean = false;

  form: FormGroup;
  mockPrevData = ['2022-09-05T03:00:00.000Z', '2022-09-08T03:00:00.000Z', 3];

  constructor(
    private fb: FormBuilder,
    private toastService: ToastService,
    private translateService: TranslateService,
    @Self()
    @Optional()
    ngControl?: NgControl,
    ) { 
    super(ngControl);
    this.form = this.fb.group({
      dateFrom: [null],
      dateTo: [null],
      calculatedDays: [0]
    });
  }

  calculateDaysDiference(a, b)
  {
    a = new Date(a);
    b = new Date(b);
    let utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    let utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
    let result = Math.floor((utc2 - utc1) / (1000 * 60 * 60 * 24));
    if(result < 0){
      return -1;
    }else{
      return result;
    }
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(){
    if(this.readonly){
      this.form.disable();
    }
    
    if(this.required && this.ngControl.control?.value){
      if(!this.ngControl.control?.value[0]){
        this.ngControl.control.setErrors({'dateFromInvalid': true});
      }
    }

    if(this.ngControl.control?.value?.length > 0){
      this.form.get('dateFrom').setValue(this.ngControl.control?.value[0] ?? null);
      this.form.get('dateTo').setValue(this.ngControl.control?.value[1] ?? null);
      this.form.get('calculatedDays').setValue(this.ngControl.control?.value[2] ?? 0);
    }
    this.form.get('calculatedDays').disable();
    this.form.valueChanges.subscribe(changes => {
      if(changes.dateFrom && changes.dateTo){
        let resultDifference  = this.calculateDaysDiference(changes.dateFrom._d, changes.dateTo._d);
        if(this.form.get('calculatedDays').value !== resultDifference){
          this.form.get('calculatedDays').setValue(resultDifference);
        }else{
          if(resultDifference == -1){
            setTimeout(()=>{
              this.form.get('dateTo').setValue(null);
              this.form.get('calculatedDays').setValue(0);
            },100)
            let msg = this.translateService.instant("DATE_RANGE.CANNOT_SET_DATETO_LESS_THAN_DATEFROM");
            this.toastService.error(msg);
          }
        }
      }
      this.ngControl.control.setValue([this.form.get('dateFrom').value,this.form.get('dateTo').value,this.form.get('calculatedDays').value]);
      if(!this.form.get('dateFrom').value){
        this.ngControl.control.setErrors({'dateFromInvalid': true});
      }
    })
  }

  handleKeyDown(e: KeyboardEvent){
    if(e.code !== "Backspace"){
      e.preventDefault();
      return;
    }
  }

  getError(errorCode: string) {
  }

  /**
   * For this operations SelectInputComponent will not manage multiple selection. For that, use SelectMultipleInputComponent
   */
     AllowedOperators: {[K in ComparableOperator]: (target: number, value: string) => boolean} = {
    [ComparableOperator.Equal]: (t, value: string) => t == Number(value),
    [ComparableOperator.NotEqual]: (t, value) => t != Number(value),
    [ComparableOperator.Contains]: null,
    [ComparableOperator.StartWith]: null,
    [ComparableOperator.EndWith]: null,
    [ComparableOperator.In]: (t, value: string) => value.split(";").map(v => Number(v)).includes(t),
    [ComparableOperator.GreaterThan]: null,
    [ComparableOperator.GreaterThanOrEqual]: null,
    [ComparableOperator.LessThan]: null,
    [ComparableOperator.LessThanOrEqual]: null,
    [ComparableOperator.IsNullOrEmpty]: (t) => !t,
    [ComparableOperator.NotIsNullOrEmpty]: (t) => !!t,
    [ComparableOperator.Between]: null,
  }

}
